module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_5010.4587ded2.png";